<template>
  <div class="container">
    <el-container>
      <el-header class="header">
        <headers />
      </el-header>
      <el-container>
        <slider />
        <el-main>
          <div class="main_box">
            <div class="main_main">
              <!-- Page Header -->
              <div class="page_header">Manage CAPA Suppliers</div>
              <!-- Page Header -->
              <div class="page_main">
                <div class="training-type-page">
                  <div class="tip-box">
                    Configure the role set used to determine approvers during
                    the formal review of CAPA requests. If no Review Board roles
                    are defined, the department list will be used.
                  </div>

                  <!-- Search Area -->
                  <el-form
                    ref="query"
                    :model="query"
                    label-position="top"
                    class="search-form"
                  >
                    <div class="form-grid">
                      <!-- Left -->
                      <div class="form-col">
                        <el-form-item label="Supplier Name / ID">
                          <el-input
                            v-model="query.title"
                            placeholder="Please enter"
                            clearable
                          />
                        </el-form-item>
                      </div>

                      <!-- Right -->
                      <!--
											<div class="form-col">
												<el-form-item label="Supplier Description">
													<el-input
														v-model="query.description"
														placeholder="Please enter"
														clearable
													/>
												</el-form-item>
											</div>
											-->
                    </div>

                    <div class="form-btns">
                      <el-button type="primary" @click="handleSearch">
                        Search
                      </el-button>
                    </div>
                  </el-form>

                  <div class="panel">
                    <div class="panel-header">
                      <h2 class="panel-title">CAPA Supplier List</h2>
                    </div>

                    <el-table
                      v-loading="tableLoading"
                      :data="tableData"
                      border
                      stripe
                      header-cell-class-name="table-header-cell"
                      cell-class-name="table-body-cell"
                      class="training-table"
                      empty-text="No Data"
                    >
                      <el-table-column
                        label="Action"
                        width="80"
                        fixed="left"
                        align="center"
                      >
                        <template slot-scope="scope">
                          <el-button
                            type="primary"
                            size="mini"
                            @click="handleEdit(scope.row)"
                          >
                            Edit
                          </el-button>
                        </template>
                      </el-table-column>

                      <el-table-column
                        prop="title"
                        label="Supplier Name / ID"
                        width="200"
                        sortable
                      />

                      <el-table-column
                        prop=""
                        label="Supplier Description"
                        sortable
                      >
                        <template slot-scope="scope">
                          {{ scope.row.description || "N/A" }}
                        </template>
                      </el-table-column>

                      <el-table-column
                        prop=""
                        label="Contact Name"
                        width="180"
                        sortable
                      >
                        <template slot-scope="scope">
                          {{ scope.row.name || "N/A" }}
                        </template>
                      </el-table-column>

                      <el-table-column
                        prop=""
                        label="Email"
                        width="180"
                        sortable
                      >
                        <template slot-scope="scope">
                          {{ scope.row.email || "N/A" }}
                        </template>
                      </el-table-column>

                      <el-table-column
                        prop=""
                        label="Phone"
                        width="160"
                        sortable
                      >
                        <template slot-scope="scope">
                          {{ scope.row.phone || "N/A" }}
                        </template>
                      </el-table-column>

                      <el-table-column prop="" label="Address" sortable>
                        <template slot-scope="scope">
                          {{ scope.row.address || "N/A" }}
                        </template>
                      </el-table-column>

                      <el-table-column label="Action" width="120" align="center">
                        <template slot-scope="scope">
                          <el-button
                            type="danger"
                            size="mini"
                            @click="handleDelete(scope.row)"
                          >
                            Delete
                          </el-button>
                        </template>
                      </el-table-column>
                    </el-table>

                    <div class="pagination">
                      <el-pagination
                        @size-change="handleSizeChange"
                        @current-change="handlePageChange"
                        :current-page="query.page"
                        :page-sizes="[5, 10, 20, 50]"
                        :page-size="query.page_size"
                        layout="total, sizes, prev, pager, next"
                        :total="pageTotal"
                      >
                      </el-pagination>
                    </div>

                    <div class="panel-footer">
                      <el-button type="primary" @click="handleAdd">
                        Add CAPA Supplier
                      </el-button>

                      <el-button type="primary" @click="handleClose">
                        Cancel
                      </el-button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </el-main>
      </el-container>
    </el-container>

    <!-- Loading -->
    <transition name="fade">
      <div class="loading" v-show="isLoading">
        <van-loading />
      </div>
    </transition>
    <!-- Loading -->
  </div>
</template>

<script>
import {
  suplierList,
  suplierDel,
} from "@/api/capaManage/configCapa/capaManageSuppliers/index";
import headers from "@/component/header.vue";
import slider from "@/component/slider.vue";

export default {
  components: {
    headers,
    slider,
  },

  data() {
    return {
      isLoading: true,
      tableLoading: false,
      query: {
        title: "",
        // description: "",
        page: 1,
        page_size: 9999,
      },
      tableData: [],
      pageTotal: 0,
    };
  },

  created() {
    let that = this;
  },

  mounted() {
    let that = this;
    that.isLoading = false;
    that.getTableData();
  },

  watch: {
    //
  },

  methods: {
    // Get table data
    getTableData() {
      let that = this;
      that.tableLoading = true;
      suplierList(that.query).then((res) => {
        that.tableLoading = false;
        if (res.code == 200) {
          that.tableData = res.data;
        }
      });
    },

    // Search
    handleSearch() {
      let that = this;
      that.getTableData();
    },

    // Change page size
    handleSizeChange(value) {
      let that = this;
      that.query.page_size = value;
      that.getTableData();
    },

    // Change current page
    handlePageChange(value) {
      let that = this;
      that.query.page = value;
      that.getTableData();
    },

    // Add
    handleAdd() {
      let that = this;
      that.goUrl("/CapaControl/manageSuppliers-add-edit");
    },

    // Edit
    handleEdit(row) {
      let that = this;
      that.$router.push({
        path: "/CapaControl/manageSuppliers-add-edit",
        query: {
          oid: row.id,
        },
      });
    },

    // Delete
    handleDelete(row) {
      let that = this;

      that
        .$confirm(
          "Are you sure you want to delete this supplier?",
          "Confirmation",
          {
            type: "warning",
          }
        )
        .then(() => {
          that.$toast.loading({
            duration: 0,
            forbidClick: true,
          });

          suplierDel({
            id: row.id,
          }).then((res) => {
            if (res.code == 200) {
              that.$toast.clear();

              that.$message.success("Operation successful");

              setTimeout(() => {
                that.getTableData();
              }, 800);
            }
          });
        })
        .catch(() => {});
    },

    handleClose() {
      let that = this;
      that.$router.back();
    },

    // Navigate to page
    goUrl(url) {
      let that = this;
      that.$router.push(url);
    },
  },
};
</script>

<style lang="less" scoped>
//主要内容
.main_main {
  .page_main {
    padding: 18px 20px;
    .pagination {
      margin: 10px 0;
      text-align: right;
    }
    .btn_el {
      margin: 10px 0 20px 0;
      .tips {
        padding: 6px 8px;
        background-color: #ffb1001a;
        border-radius: 6px;
        font-size: 16px;
        font-weight: bold;
      }
    }
  }
  //页头
  .page_header {
    padding: 0 20px;
    height: 60px;
    line-height: 60px;
    background-color: #d8e4f0;
    font-size: 24px;
    font-weight: bold;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.075);
  }
}
</style>
<style scoped>
.main_box {
  height: calc(100vh - 60px);
  overflow-y: auto;
}
.main_box .main_main {
  position: relative;
  min-height: calc(100% - 0px);
  max-height: auto;
  background-color: #fafafa;
}
.el-header,
.el-main {
  padding: 0;
}

.training-type-page {
  padding: 16px 12px 30px;
  background: #f5f6f7;
  min-height: 100vh;
  box-sizing: border-box;
}

.tip-box {
  background: #f6efdf;
  border-radius: 4px;
  color: #333;
  padding: 14px 16px;
  margin-bottom: 14px;
  font-size: 14px;
  line-height: 24px;
}

.tip-title {
  font-weight: 700;
}

.tip-list {
  margin: 8px 0 0 18px;
  padding: 0;
}

.tip-list li {
  line-height: 26px;
}

.panel {
  background: #fff;
  border: 1px solid #dcdfe6;
}

.panel-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 10px 12px 8px;
  border-bottom: 1px solid #dcdfe6;
}

.panel-title {
  margin: 0;
  font-size: 22px;
  font-weight: 700;
  color: #222;
}

.panel-tools {
  display: flex;
  align-items: center;
  gap: 8px;
}

.search-input {
  width: 220px;
}

.collapse-btn {
  width: 28px;
  height: 28px;
  padding: 0;
}

.training-table {
  width: 100%;
}

.form-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-column-gap: 24px;
  align-items: start;
}
.form-grid .el-form-item {
  margin-bottom: 0;
}
.form-btns {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 12px;
  margin-top: 20px;
  margin-bottom: 20px;
}

::v-deep .table-header-cell {
  background: #fff !important;
  color: #222;
  font-weight: 700;
  font-size: 16px;
}

::v-deep .table-body-cell {
  color: #222;
  font-size: 15px;
}

::v-deep .el-table td,
::v-deep .el-table th {
  padding: 14px 0;
}

::v-deep .el-table--border th,
::v-deep .el-table--border td {
  border-right: 1px solid #dcdfe6;
}

::v-deep .el-button--mini {
  padding: 7px 12px;
  font-size: 14px;
}

.panel-footer {
  display: flex;
  justify-content: center;
  gap: 12px;
  padding: 24px 0 28px;
}

::v-deep .btn span {
  text-decoration: underline;
}
</style>

